export default {
      id: "common__plant_machine-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__plant_machine",
      toString: function () {
        return this.url;
      }
    }